import { render, staticRenderFns } from "./profits-list.vue?vue&type=template&id=09070aa0&scoped=true&"
import script from "./profits-list.vue?vue&type=script&lang=js&"
export * from "./profits-list.vue?vue&type=script&lang=js&"
import style0 from "./profits-list.vue?vue&type=style&index=0&id=09070aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09070aa0",
  null
  
)

export default component.exports